import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ['holder']

    connect() {
        const triggerElements = this.element.querySelectorAll('.scroll-trigger');
        triggerElements.forEach((el) => {
            el.addEventListener('click', (event) => {

                const header = document.querySelector('header');

                window.scrollTo({
                    top: this.holderTarget.offsetTop - header.offsetHeight,
                    behavior: 'smooth'
                });
            });
        });
    }
}